import { render, staticRenderFns } from "./ship-tab-view.vue?vue&type=template&id=5c04fe8a&scoped=true&"
import script from "./ship-tab-view.vue?vue&type=script&lang=js&"
export * from "./ship-tab-view.vue?vue&type=script&lang=js&"
import style0 from "./ship-tab-view.vue?vue&type=style&index=0&id=5c04fe8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04fe8a",
  null
  
)

export default component.exports